// extracted by mini-css-extract-plugin
export default {"title":"InfoHead_title__Tn4I4","paragraph":"InfoHead_paragraph__9AZ1T","subTitle":"InfoHead_subTitle__XOPVR","img":"InfoHead_img__6zTbz"};